export default "__VITE_ASSET__CAL2duy7__"